import { useMutation } from '@tanstack/react-query';
import { setAnswer } from '../queries/post';

interface IAnswerPayload { answer: string, question: string, simulated: string }

export function useSetAnswer() {
  const { mutate } = useMutation({
    mutationKey: ['setPracticeAnswer'], 
    mutationFn: ({ answer, question, simulated }: IAnswerPayload) => setAnswer(answer, question, simulated),
    retry: false
  });

  return { mutate };
}
